module.exports = __webpack_public_path__ + "static/media/phonepay.de5423ea.svg";